import { render, staticRenderFns } from "./CancelarPlano.vue?vue&type=template&id=664343ba"
import script from "./CancelarPlano.vue?vue&type=script&lang=ts"
export * from "./CancelarPlano.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports